import _ from 'lodash';
import localforage from 'localforage';

const DEFERRED_SEARCH_EVENT_KEY = 'deferred-search-event';

// Due to this issue:
// https://github.com/localForage/localForage/issues/843
// We cannot use the default driver order, which prefers INDEXEDDB.
// LOCALSTORAGE is confirmed to work on Firefox/Chrome/Safari/Opera
const eventStore = localforage.createInstance({
  driver: localforage.LOCALSTORAGE,
  name: 'livewire_stat_event',
  storeName: 'deferred',
  version: _.get(window, 'Livewire.version', '1.0'),
});

const cacheStore = localforage.createInstance({
  driver: localforage.LOCALSTORAGE,
  name: 'livewire_cache',
  storeName: 'api',
  version: _.get(window, 'Livewire.version', '1.0'),
});

export {
  DEFERRED_SEARCH_EVENT_KEY,
  cacheStore,
  eventStore,
};
